module.exports = __webpack_public_path__ + "h5/img/wechat_login.bee72fc6.png";